import styled from 'styled-components';

export const Container = styled.div`
    border-radius: 9px 9px 0px 0px;
    width: 100%;
    height: 32px !important;
    position: relative !important;
    font-family: Gilroy-Medium, sans-serif !important;
    font-weight: 400 !important;
    text-transform: uppercase !important;
    font-size: 11px !important;
    color: rgba(255, 255, 255, 0.55) !important;
    background-color: rgba(0, 0, 0, 0.1) !important;
    display: flex;
    overflow:hidden;
}
`;

export const TitleArea = styled.div`
    width: 90%;
}
`;

export const OptionsArea = styled.div`
    width: 10%;
    height: 100%
}
`;
